import TopBar from "@/components/TopBar";
import VesselSwitcher from "@/components/VesselSwitcher";
import { useResolvedVessel, vesselNav } from "@/lib/nav";

/**
 * The top bar as every signed-in page shows it: the screen links for the
 * pool the page is about (or the one you last looked at), the switcher, the
 * theme and the account. One component so the guide, the account page and
 * the console all carry exactly the bar the dashboard does.
 */
export default function SignedInBar({ wide = false }: { wide?: boolean }) {
  const { id, vessels } = useResolvedVessel();
  return <TopBar nav={vesselNav(id)} switcher={vessels.length > 0 ? <VesselSwitcher /> : undefined} wide={wide} />;
}
